<template>
  <div class="page-container">
    <div class="query-title">经销商开票情况明细报表（简）</div>

    <div class="content">
      <QueryParams ref="QueryParams" :loading="loading" :search-field="searchField" @search="queryData" />
      <div class="table-container">
        <Table-filter
          title="明细"
          :rt-columns="rtColumns1"
          :lt-columns="ltColumns1"
          :grid-columns="gridOptions.columns"
          :count-data="countFileds"
          :all-options="allOptions"
          :pagination="pagination"
          @pagination-change="handleTablePaginationChange"
          @confirm="tableConfigConfirm"
        >
          <template #button>
            <!-- <table-button name="export" tip="导出" @click="exportExcel" /> -->
            <table-button name="export" tip="导出" @click="exportExcel2('xlsx')" />
          </template>
          <vxe-grid
            ref="xTable"
            v-loading="loading"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            height="300"
            max-height="500"
            align="left"
            size="mini"
            show-overflow
            :sort-config="{ multiple: true }"
            :empty-render="{name: 'NotData'}"
            :filter-config="{ remote: true }"
            :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptions.columns"
            :data="gridOptions.data"
            :row-class-name="rowClassName"
            @filter-change="filterChangeEvt"
          >
            <template #trans_time="{row}">
              <span>{{ row.trans_time_text }}</span>
            </template>
            <template #gjahr="{row}">
              <span>{{ row.gjahr_text }}</span>
            </template>
          </vxe-grid>
        </Table-filter>
      </div>
    </div>

    <table-custom-filter ref="CustomFilter" :current-filter-field="currentFilterField" @confirm="customeFilter" />

  </div>
</template>

<script>
import { reportFormSimple } from '@/api/sap/report'
import tableMixins from '@/utils/tableMixins'
import pageConfig, { pageSearch } from './config/dealersMakeInvoiceReportFormsSimple'
import { frontExport, concurrencyReq, sapDownloadFile } from '@/utils/frontExport'
import { mapGetters } from 'vuex'
export default {
  mixins: [tableMixins],
  data() {
    return {
      loading: false,
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      gridOptions: {
        columns: [],
        data: []
      },
      pageSearch,
      searchField: {},
      isSetFilter: false
    }
  },
  computed: {
    ...mapGetters(['role'])
  },
  created() {
    this.initPage(pageConfig)
    console.log(this.gridOptions.columns)
  },
  methods: {
    async queryData(page, ranges) {
      if (page === 1) {
        this.pagination.page = page
        if (ranges) {
          // 保存 查询组件的查询参数
          this.ranges = ranges
          this.handleRanges(ranges)
        }
        this.isSetFilter = false
      }
      const params = {
        user_bp: this.role.USER_BP,
        role: this.role.ROLE,
        ...this.allConditions,
        ...this.pagination,
        is_result: 1,
        sort: this.sortData.concat(this.tableSort)
      }
      this.loading = true
      try {
        const { data, total, calculation, field, file } = await reportFormSimple(params)
        if (data.length === 0 && (total - 0)) {
          this.queryData(1, ranges)
          return
        }
        this.fileData = file
        this.pagination.totalCount = total - 0
        this.calculation = this.filtercalculation(calculation)
        // 更新计算值
        this.updateCount()
        if (this.showHeader) {
          this.gridOptions.data = this.tableCountData.concat(data)
        } else {
          this.gridOptions.data = data.concat(this.tableCountData)
        }
        this.allOptions = this.filterAllOptions(field)
        this.setFilter()
      } catch (e) {
        //
      }
      this.loading = false
    },
    // 导出全部 导出本页
    async exportExcel() {
      const params = {
        user_bp: this.$store.getters.role.USER_BP,
        ...this.allConditions
      }
      const data = await concurrencyReq(this.pagination.totalCount, params, reportFormSimple)
      frontExport(this.gridOptions.columns, data, '经销商开票情况明细报表')
    },
    // 导出全部 导出本页
    async exportExcel2() {
      const params = {
        user_bp: this.role.USER_BP,
        role: this.role.ROLE,
        ...this.allConditions,
        ...this.pagination,
        is_download: 'X',
        sort: this.sortData.concat(this.tableSort)
      }
      const { file } = await reportFormSimple(params)
      this.fileData = file
      let s = ''
      this.allConditions?.mak_date?.map(item => {
        if (item.low && item.high) {
              s += `,${item.low}-${item.high}`
            } else if (item.low) {
              s += `,${item.low}`
            }
      })

      sapDownloadFile(this.fileData, `经销商开票情况明细报表${s}.xlsx`)
    },
    handleTablePaginationChange(pages) {
      Object.assign(this.pagination, pages)
      this.queryData()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/report-forms-manage/dealersMakeInvoiceReportFormsSimple.vue